import { Component, EventEmitter, forwardRef, Output, ViewChild } from '@angular/core';
import { NgbTypeahead, NgbTypeaheadModule } from '@ng-bootstrap/ng-bootstrap';
import { Observable, Subject, merge, OperatorFunction } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, map } from 'rxjs/operators';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { LayerService } from '../../services/layer.service';

@Component({
	selector: 'bp-wms-layer-input',
	imports: [NgbTypeaheadModule, FormsModule],
	templateUrl: './wms-layer-input.html',
	styleUrls: ['./wms-layer-input.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => WmsLayerInputComponent),
      multi: true
    }
  ]
})
export class WmsLayerInputComponent {
	@ViewChild('instance', { static: true }) instance!: NgbTypeahead;
	@Output() searchClick = new EventEmitter<void>();

	value: any = '';
  onChange = (_: any) => {};
  onTouched = () => {};

  // Called when internal input changes
  onInputChange(value: any): void {
    this.value = value;
    this.onChange(value);
    this.onTouched();
  }

  // ControlValueAccessor methods
  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: (_: any) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    // Optional: Implement if you want to handle [disabled] binding
  }

	focus$ = new Subject<string>();
	click$ = new Subject<string>();
	
	servers: string[];

	constructor(private ls: LayerService) {
		this.servers = this.ls.serverNames();
	}
	
	search: OperatorFunction<string, readonly string[]> = (text$: Observable<string>) => {
		const debouncedText$ = text$.pipe(debounceTime(200), distinctUntilChanged());
		const clicksWithClosedPopup$ = this.click$.pipe(filter(() => !this.instance.isPopupOpen()));
		const inputFocus$ = this.focus$;

		return merge(debouncedText$, inputFocus$, clicksWithClosedPopup$).pipe(
			map((term) =>
				(term === '' ? this.servers : this.servers.filter((v: string) => v.toLowerCase().indexOf(term.toLowerCase()) > -1)),
			),
		);
	};
}
